import { useEffect } from 'react';
import { Game as GameType } from '~types';
import { createGlobalState } from 'react-use';

export type WinItemStateTypes = GameType | number | undefined;

const useItemsLeftValue = createGlobalState<GameType[]>([]);
const useIdsItemsLeftValue = createGlobalState<number[]>([]);
const useUpgradeAmountValue = createGlobalState<number>(0);
const useItemRightValue = createGlobalState(null);
const useModeValue = createGlobalState<number>(0);
const useWinGameValue = createGlobalState<WinItemStateTypes>(0);
const useLooseGameValue = createGlobalState<WinItemStateTypes>(0);
const useWinGamesValue = createGlobalState([]);
const useStatusGameValue = createGlobalState<number>(0);
const useLineValue = createGlobalState<number>(0);
const useChanceValue = createGlobalState<number>(0);

export const useChance = () => useChanceValue();
export const useLine = () => useLineValue();
export const useItemsLeft = () => useItemsLeftValue();
export const useIdsItemsLeft = () => useIdsItemsLeftValue();
export const useUpgradeAmount = () => useUpgradeAmountValue();
export const useItemRight = () => useItemRightValue();
export const useMode = () => useModeValue();
export const useWinGames = () => useWinGamesValue();
export const useLoseGame: typeof useLooseGameValue = () => {
  const [looseItem, setLooseItem] = useLooseGameValue();
  const [statusGame, setStatusGame] = useStatusGameValue();
  const [upgradeAmount] = useUpgradeAmountValue();
  const [itemRight] = useItemRightValue();

  useEffect(() => {
    if (statusGame === 3) {
      if (upgradeAmount > 0) {
        setLooseItem(0);
        setStatusGame(0);
      } else if (itemRight) {
        setLooseItem(0);
        setStatusGame(0);
      }
    }
  }, [upgradeAmount, itemRight, statusGame]);

  return [looseItem, setLooseItem];
};

export const useWinItem: typeof useWinGameValue = () => {
  const [winItem, setWinItem] = useWinGameValue();
  const [statusGame, setStatusGame] = useStatusGameValue();
  const [upgradeAmount] = useUpgradeAmountValue();
  const [itemRight] = useItemRightValue();

  useEffect(() => {
    if (statusGame === 3) {
      if (upgradeAmount > 0) {
        setWinItem(0);
        setStatusGame(0);
      } else if (itemRight) {
        setWinItem(0);
        setStatusGame(0);
      }
    }
  }, [upgradeAmount, itemRight, statusGame]);

  return [winItem, setWinItem];
};
export const useStatusGame = () => useStatusGameValue();
